export default [
  {
    title: '첨단산업의 집약체 <br>데이터센터 각 세종',
    desc: '국내 최대 규모인 하이퍼스케일 데이터센터 <br>각 세종은 첨단 로봇 시스템을 중심으로 한 <br>첨단산업의 집약체입니다.',
    srcMo: '/img/about/idea/idea-s3-c1.s.jpg',
    imgSrc: '/img/about/idea/idea-s3-c1.xxl.jpg'
  },
  {
    title: '환경은 온전하게 <br>데이터는 안전하게 <br>데이터센터 각 춘천',
    desc: '자연의 특성을 적극적으로 활용하여 완성한 데이터센터 각 춘천은 네이버의 첫 번째 데이터센터입니다.',
    srcMo: '/img/about/idea/idea-s3-c2.s.jpg',
    imgSrc: '/img/about/idea/idea-s3-c2.xxl.jpg'
  },
  {
    title: '세계를 잇는 하나의 거점 <br>데이터센터 각 글로벌',
    desc: '전 세계 10개국에 위치한 데이터센터 각 글로벌은 <br>검증된 인프라를 기반으로 언제 어디서나 동일한 <br>클라우드 환경을 제공합니다.',
    srcMo: '/img/about/idea/idea-s3-c3.s.jpg',
    imgSrc: '/img/about/idea/idea-s3-c3.xxl.jpg'
  }
];
